import RulesDetails from './components/rulesDetails/RulesDetails';

const RulesTab = () => {    
    return ( <RulesDetails></RulesDetails>);
}

export default RulesTab;
